import { render, staticRenderFns } from "./custom.vue?vue&type=template&id=72ad21a0&scoped=true&"
import script from "./custom.vue?vue&type=script&lang=ts&"
export * from "./custom.vue?vue&type=script&lang=ts&"
import style0 from "./custom.vue?vue&type=style&index=0&id=72ad21a0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ad21a0",
  null
  
)

export default component.exports